import PropTypes from "prop-types";
import classNames from "classnames";
import React from "react";

export const FormLabel = ({ name, value, label, className, valueClassName }) => {
  const inputClassName = classNames("input__value", valueClassName);

  return (
    <fieldset className={className}>
      <label htmlFor={name} className="input__label">
        {label}
      </label>

      <p name={name} className={inputClassName}>
        {value}
      </p>
    </fieldset>
  );
};

FormLabel.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  valueClassName: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormLabel.js